module.exports = __webpack_public_path__ + "img/vasco.daa211c2.jpg";